
const hostname =  'https://be-esd.azolla.sg';

export { hostname };
